
// @ is an alias to /src
import { defineComponent, ref } from "vue";
import DependentModal from "../components/DependentModal.vue";
import DeleteModal from "../components/DependentDelete.vue";
import AppFooter from "@/components/common/AppFooter.vue";
import messages from "@/config/messages";
import helper from "@/utils/helper";
import common from "@/config/common";
import routesPath from "@/config/routesPath";
import { mapMutations, mapGetters } from "vuex";
import * as apiClient from "@/apiclient/";
import eventBus from "@/utils/eventBus";

interface DependentData {
  electionDependentId: number;
  electionId: number;
  benefits: Array<string>;
  firstName: string;
  lastName: string;
}
const relationshipLabels: { [key: number]: string } = {
  1: "Spouse",
  2: "Child",
  3: "Parent",
  4: "Other",
};

export default defineComponent({
  name: "DependentsView",
  components: {
    DependentModal,
    DeleteModal,
    AppFooter,
  },
  data() {
    return {
      validationMsg: "",
      action: "",
      showModal: false,
      showDeleteModal: false,
      dependentAlldata: [] as apiClient.GetAllDependentDto[],
      selectedElectionDependentId: 0,
      selectedElectionId: 0,
      dependentBenefits: [] as string[],
      messages,
      saveBtnTxt: "SKIP & NEXT",
    };
  },
  mounted() {
    eventBus.emit("toggle-enrollments-menu", false);
    this.getAllData();
  },
  beforeRouteLeave(to, from, next) {
    helper.beforeRouterLeave(next);
  },
  computed: {
    ...mapGetters(["getFormDirty", "getEnrollment"]),
  },
  methods: {
    ...mapMutations([
      "setFormDirty",
      "setShowModal",
      "setModalTitle",
      "setModalContent",
    ]),
    async submitHandler() {
      helper.setPageStep(common.pageStep.dependents);
      this.$router.push({ name: routesPath.benefits });
    },
    async backButtonHanlder() {
      this.$router.push({
        name: routesPath.profileInformation,
      });
    },
    formatDate(date: string): string {
      return helper.formatDate(date);
    },
    getRelationshipLabel(relationshipId: number): string {
      return relationshipLabels[relationshipId] || "";
    },
    openModal() {
      this.validationMsg = "";
      this.dependentBenefits = [];
      this.selectedElectionDependentId = 0;
      this.action = "add";
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.setFormDirty(false);
      this.selectedElectionDependentId = 0;
    },
    submitModal() {
      this.closeModal();
    },
    openModifyModal(allData: DependentData) {
      this.validationMsg = "";
      this.selectedElectionDependentId = allData.electionDependentId;
      this.selectedElectionId = allData.electionId;
      this.dependentBenefits = allData.benefits;
      this.action = "edit";
      this.showModal = true;
    },

    closeDleteModal() {
      this.showDeleteModal = false;
    },
    openDeleteModal(dependent: DependentData) {
      if (dependent.benefits.length) {
        dependent.benefits.join(", ");
        const modalContent = messages.dependentNoDelete
          .replaceAll("{dependent_first_name}", dependent.firstName)
          .replace("{dependent_last_name}", dependent.lastName)
          .replace("{all_benefits}", dependent.benefits.join(", "));
        this.setShowModal(true);
        this.setModalTitle("Alert!");
        this.setModalContent(modalContent);
        return;
      }
      this.selectedElectionDependentId = dependent.electionDependentId;
      this.showDeleteModal = true;
    },
    async getAllData(): Promise<void> {
      const params = {
        customerParticipantId: this.getEnrollment.customerParticipantId,
      };
      const result = await apiClient
        .dependentController()
        .getApiDependentGetAll(params);
      if (!result || result.error) {
        if (result.error) {
          this.validationMsg = result.error + messages.errorMsg;
        }
        return;
      } else if (result.data) {
        this.dependentAlldata = result.data;
        if (this.dependentAlldata.length) {
          this.saveBtnTxt = common.saveNext;
        } else {
          this.saveBtnTxt = common.skipNext;
        }
      }
    },
  },
});
